export enum EAdornmentPlacement {
  START = 'start',
  END = 'end',
}
